import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import { Client } from '@microsoft/microsoft-graph-client';

const VUE_APP_AZURE_AUTHORITY = 'https://login.microsoftonline.com/organizations';

const config_auth_clientId = {
    'central': '04d4d406-9630-4ff5-914d-c6b61682f4c2',
    'dev': '14f31e57-f38a-4d4c-a95c-2b0ff739523d',
    'east': 'c42415ac-db59-4b40-8bfc-efa1432b5a5a',
    'localhost': '80a3f629-4042-421b-9456-27a87480692e',
    'mountain': '82e84b40-1274-48cf-a6be-7022086788c0',
    'staging': '3f0dea6a-f6b5-4a80-bf35-5933512cd2b6',
    'test': '6d609759-ddc8-460c-84ee-2a195e89f2a2',
    'west': '84a2a239-f6e9-4dfb-bff7-e8f876fbdce0'
};

export default {

    async signInWithAD() {
        let host_region = document.location.hostname.toLowerCase().split('.')[0];
        if(!config_auth_clientId[host_region]) {
            throw new Error('Invalid host region');
        }
        try {
            const config = {
                auth: {
                    clientId: config_auth_clientId[host_region],
                    authority: VUE_APP_AZURE_AUTHORITY,
                    redirectUri: document.location.origin + '/',
                },
                cache: {
                    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
                    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
                },
            };
            let publicClientApplication = new PublicClientApplication(config);

            const AuthProviderOptions = {
                account: {},
                scopes: ['openid', 'profile', 'User.Read'],
                interactionType: InteractionType.Popup,
            };

            // Pass the PublicClientApplication instance from step 2 to create AuthCodeMSALBrowserAuthenticationProvider instance
            const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
                publicClientApplication,
                AuthProviderOptions
            );

            // Initialize the Graph client
            const graphClient = await Client.initWithMiddleware({ authProvider });

            let graphUser = await graphClient.api('/me')
                .select('id,displayName,userPrincipalName,mail,companyName,street,streetaddress,city, state,postalcode,officeLocation,mobilePhone,businessPhones')
                .get();
            return graphUser;
        } catch (err) {
            console.log(err);
        }
    },

    signOutWithAD: async function (graphUser) {
        let host_region = document.location.hostname.toLowerCase().split('.')[0];
        if(!config_auth_clientId[host_region]) {
            throw new Error('Invalid host region');
        }
        const config = {
            auth: {
                clientId: config_auth_clientId[host_region],
                authority: VUE_APP_AZURE_AUTHORITY,
                redirectUri: document.location.origin + '/',
            }
        };

        let client = PublicClientApplication(config);
        // you can select which account application should sign out
        const logoutRequest = {
            account: client.getAccountByHomeId(graphUser.id),
            mainWindowRedirectUri: document.location.origin + '/',
        };

        await client.logoutPopup(logoutRequest);
    }
};